export function Flame() {
  return <span className="flame" aria-hidden="true" />;
}

export function StarIcon() {
  return <span className="star" aria-hidden="true" />;
}
